module.exports = __webpack_public_path__ + "img/2.e46b1d5c.jpeg";